import * as Yup from "yup";

// Console password rule (HXSMSF-149), the same as the backend check: at least
// 8 characters, upper- and lowercase letters, and a number. Symbols are allowed.
export const PASSWORD_RULES = ["length", "case", "number"];

// Which rules a password meets, for the live hints (keys match PASSWORD_RULES
// and auth.passwordRequirements).
export const passwordChecks = (password = "") => ({
  length: password.length >= 8,
  case: /[a-z]/.test(password) && /[A-Z]/.test(password),
  number: /[0-9]/.test(password),
});

export const passwordSchema = (t) =>
  Yup.string()
    .min(8, t("auth.activate.validation.minLength"))
    .test("complexity", t("auth.activate.validation.complexity"), (value) => {
      const checks = passwordChecks(value || "");
      return checks.case && checks.number;
    });
